import { BreadcrumbJsonLd } from "next-seo";
import { ItemListElements } from "next-seo/lib/jsonld/breadcrumb";
import Link from "next/link";
import { Typography } from "shared/components/atoms/Typography";
import styled from "styled-components";

const Wrapper = styled.ul<{ transparent?: boolean }>`
  width: 100%;
  background: ${(props) => (props.transparent ? "transparent" : "#f3f7fd")};
  padding: 6px 16px;
  box-sizing: border-box;
`;

const List = styled.li<{ transparent?: boolean }>`
  font-family: HiraginoSans-W3;
  font-size: 8px;
  color: ${(props) => (props.transparent ? "#fff" : "#838d9b")};
  letter-spacing: 0.2px;
  line-height: 19px;
  display: inline;
  white-space: nowrap;
  margin-right: 8px;
`;

const StyledTypography = styled(Typography)<{
  transparent: boolean;
}>`
  color: ${(props) => (props.transparent ? "#fff" : "#838d9b")};
  white-space: pre-wrap;
`;

const Arrow = styled.span<{ transparent?: boolean }>`
  margin-left: 8px;
`;

interface Props {
  itemListElements: ItemListElements[];
  transparent?: boolean;
}

export const Breadcrumb = ({
  itemListElements,
  transparent = false,
  ...rest
}: Props) => {
  return (
    <Wrapper transparent={transparent} {...rest}>
      {itemListElements.map((list, index) => (
        <List key={index} transparent={transparent}>
          <Link href={list.item} passHref>
            <StyledTypography as="a" transparent={transparent}>
              {list.name}
            </StyledTypography>
          </Link>
          {itemListElements.length - 1 !== index && <Arrow>{`>`}</Arrow>}
        </List>
      ))}
      <BreadcrumbJsonLd itemListElements={itemListElements} />
    </Wrapper>
  );
};

export const AbsoluteBreadcrumb = styled(Breadcrumb)`
  position: absolute;
  top: 0;
  left: 0;
`;
